// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PostSensorLogRequestModel from '../../model/post-sensor-log-request-model';
import PostSensorLogRequestDTO from '../dto/post-sensor-log-request-dto';
import dtoSchema from '../schemas/post-sensor-log-request-schema';
import Deveui_UplinkModel from '../../model/deveui-uplink-model';

export default abstract class PostSensorLogRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PostSensorLogRequestDTO>) {
    super();
    if (data) {
      this.requestData = Deveui_UplinkModel.toModel(data.requestData);
    }
  }
  /**
  */
  requestData?: Deveui_UplinkModel;

  static toModel(dto: DeepPartial<PostSensorLogRequestDTO>): PostSensorLogRequestModel;
  static toModel(dto: DeepPartial<PostSensorLogRequestDTO> | undefined | null): PostSensorLogRequestModel | undefined;
  static toModel(dto: DeepPartial<PostSensorLogRequestDTO> | undefined | null): PostSensorLogRequestModel | undefined {
    return dto ? new PostSensorLogRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PostSensorLogRequestModel> | PostSensorLogRequestModel): PostSensorLogRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      requestData: unwrapped.requestData,
    } as PostSensorLogRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PostSensorLogRequestModel, can not map to PostSensorLogRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
